import type { SetURLSearchParams } from 'react-router'

export type ClientFilters = {
	search: string
	tezOnly: boolean
}

export function parseClientFilters(params: URLSearchParams): ClientFilters {
	return {
		search: params.get('q') ?? '',
		tezOnly: params.get('tez') === '1',
	}
}

/** Update client filters without adding a history entry for each change. */
export function replaceClientFilters(
	setParams: SetURLSearchParams,
	filters: Partial<ClientFilters>,
) {
	setParams(
		(prev) => {
			const next = new URLSearchParams(prev)

			if ('search' in filters) {
				if (filters.search) next.set('q', filters.search)
				else next.delete('q')
			}

			if ('tezOnly' in filters) {
				if (filters.tezOnly) next.set('tez', '1')
				else next.delete('tez')
			}

			return next
		},
		{ replace: true },
	)
}
